function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResistance = function SvgResistance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "-116.2 -61.7 194.9 213",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 13,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M72.1-10.7     C11.3-31.9-18.8-55.2-18.8-55.2s-30.1,23.4-90.9,44.5c0,0-2.5,58.1,24.1,97.4c26.6,39.2,66.8,58.1,66.8,58.1S21.3,125.8,48,86.6     C74.6,47.4,72.1-10.7,72.1-10.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: -20.5,
    cy: 64.6,
    r: 18.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M23.5,55.8     c0.2-6.5-0.6-13.1-2.2-19.6C16.6,17,5.8-4.6-11.4-15.5c4,7.8,4.6,17,3.2,25.6c-1,6.4-3.6,13.3-9.1,17.1c-5.5,3.8-13.5,4.2-19.3,0.8     c-6.5-3.8-9.8-11.3-11.1-18.4c-5.6,8.1-10.5,16.1-13.5,25.5c-2.1,6.7-3.5,13.6-3.4,20.6h0c0,25,19.7,45.2,44.1,45.2     S23.5,80.8,23.5,55.8L23.5,55.8z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResistance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resistance.f8d29cf5.svg";
export { ForwardRef as ReactComponent };